export default {"src":"/_next/static/media/ri-fieldlab.27e853c5.svg","height":56,"width":300,"blurWidth":0,"blurHeight":0};